import { LineAmountTypes } from "../../enums/line-amount-items";
import { CurrencyCode } from "../../enums/currency-code";
import { LineItems } from "../../models/credit-note/line-item";
import { Contact } from "../../models/credit-note/contact";
import { Guid } from "guid-typescript";
import { Organization } from "src/app/modules/suppliers/models/organization/organization";

export class CreditNoteDTO {
  invoiceID: Guid;
  type: string;
  status?: string;
  lineAmountTypes?: string;
  currency?: CurrencyCode;
  contact: Contact;
  date?: Date;
  lineItems: LineItems[] = [];
  // Per-line QBO customer ids, parallel to lineItems (SD-1177).
  lineCustomerIds?: string[] = [];
  // Per-line QBO class ids, parallel to lineItems (SD-1177).
  lineClassIds?: string[] = [];
  subTotal?: number;
  totalTax?: number;
  total?: number;
  creditNoteID?: string;
  fullyPaidOnDate?: Date;
  creditNoteNumber?: string;
  invoiceNumber?: string;
  sentToContact?: boolean;
  currencyRate?: number;
  currencyCode: string;
  remainingCredit?: number;
  brandingThemeID?: Guid;
  hasAttachments?: boolean;
  hasErrors?: boolean;
  validationErrors?: string[];
  OrganisationId?: string;
  PdfUrl?: string;
  InvoiceOrCreditNote: string;
  unreconciledReportIds: string = '';
  constructor(organisationId: string
  ) {

    this.OrganisationId = organisationId,
      this.type = 'ACCPAYCREDIT',
      this.contact = null,
      this.lineAmountTypes = LineAmountTypes.Exclusive,
      this.status = "AUTHORISED",
      this.lineItems = [],
      this.currency = CurrencyCode.AUD,
      this.currencyCode = CurrencyCode.AUD,
      this.date = null;
  }
}
